import { Routes } from '@angular/router';

// component nicht über index laden, ergibt runtime fehler
import { PackagingComponent } from './packaging.component';
import { AuthGuard } from '../services/index';
import { PackagingItemComponent } from './packaging-item/packaging-item.component';

export const packagingRoutes: Routes = [
    { path: 'packaging', component: PackagingComponent, canActivate: [AuthGuard]  },
    { path: 'packaging/:id', component: PackagingItemComponent, canActivate: [AuthGuard]  }
];


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/packaging/packaging.routes.ts